import {ProductScript} from "../../../../api/Products";
import {useAsync2} from "nate-react-api-helpers";
import {api} from "../../../../api/API";
import {useRef, useState} from "react";
import {getAll} from "../../../logistics/routes/useGetAll";
import {Alert, Button, List, ListItem, ListItemButton, ListItemSecondaryAction, ListItemText} from "@mui/material";
import {Delete} from "@mui/icons-material";
import {grey} from "@mui/material/colors";
import {EditScript} from "./EditScript";

export function ProductScripting(props: {
    product?: number;
    value: ProductScript[] | undefined;
    onChange(input: ProductScript[] | undefined): void;
}) {
    const [show, setShow] = useState<ProductScript>();

    const changeRef = useRef(props.onChange);
    changeRef.current = props.onChange;

    const load = useAsync2(async (input) => {
        if(input.scripts !== undefined) return input.scripts;

        const product = input.product;
        if(!product) {
            changeRef.current([]);
            return;
        }

        const rs = await getAll(null, offset => api.products.listScripts({
            product: product,
            offset,
        }), {useLazy: true});

        changeRef.current(rs);
        return rs;
    }, {
        product: props.product,
        scripts: props.value,
    }, [props.product, props.value]);

    return (
        <div>
            <Alert severity="info">
                Scripts can be used to calculate complex values that can be used in dimension formulas
                or dynamic SKUs.

                <div style={{marginTop: 8}}>
                    Examples:
                </div>
                <ul style={{marginTop: 0}}>
                    <li>Dynamic SKU: {"ABH10039{c.my_script}"}</li>
                    <li>Dimension: {"door.width + c.lite_calculator"}</li>
                </ul>
            </Alert>

            {load.LoadingOrErrorElement}

            <List>
                {(props.value || [])
                    .filter(v => !v.archived)
                    .map(a => <ListItemButton onClick={() => setShow(a)}>
                        <ListItemText
                            primary={a.name}
                            secondary={`Reference as c.${a.name}`}
                        />

                        <ListItemSecondaryAction onClick={e => {
                            e.stopPropagation();

                            props.onChange((props.value || []).map(v => {
                                if(v === a) return Object.assign({}, v, {archived: true});
                                return v;
                            }))
                        }}>
                            <Delete />
                        </ListItemSecondaryAction>
                    </ListItemButton>)}

                {(props.value || []).length === 0 && <>
                    <ListItem>
                        <ListItemText
                            primary="No scripts yet"
                            style={{color: grey["600"]}}
                        />
                    </ListItem>
                </>}
            </List>

            <Button onClick={() => {
                setShow({
                    id: 0,
                    name: "",
                    script: "",
                    archived: false,
                })
            }}>New Script</Button>

            {show && <EditScript
                value={show}
                onClose={() => setShow(undefined)}
                onSave={v => {
                    if(!show) return;

                    const list = (props.value || []).slice();
                    const i = list.indexOf(show);
                    if(i === -1) {
                        list.push(v);
                    } else {
                        list[i] = v;
                    }

                    changeRef.current(list);
                }}
            />}
        </div>
    )

}